import { Component } from '@angular/core';

@Component({
    selector: 'ups-list-head-controls',
    template: require('./ups-list-head-controls.component.html')
})
/** ups-list-head-controls component*/
export class UpsListHeadControlsComponent {
    /** ups-list-head-controls ctor */
    constructor() {

    }
}